import axios from "axios"

const developmentURL = "http://localhost:5005"
const productionURL = "https://api.qrseller.com"

// export const baseURL =
//   process.env.NODE_ENV === "development" ? developmentURL : productionURL;

export const baseURL = import.meta.env.VITE_STAGE === "local" ? developmentURL : productionURL

console.log("import.meta.env.VITE_STAGE", import.meta.env.VITE_STAGE)
console.log("baseURL", baseURL)

export const client_url = "https://qrseller-client.netlify.app/"

